module.exports = __webpack_public_path__ + "img/button_sports_off_en.6a6417c8.png";